import { Fragment, type ReactNode } from 'react'

/**
 * Minimal inline markup for prompts: `**bold**` and `*italic*`.
 *
 * Deliberately builds React nodes rather than setting HTML — content comes from
 * the item bank and must stay strictly declarative (§7.4). KaTeX typesetting of
 * `$…$` spans is not implemented yet; until it is, math markup renders as literal text,
 * which is visible and honest rather than silently wrong.
 */
export function Markup({ text }: { text: string }) {
  return <>{parseInline(text)}</>
}

const TOKEN = /(\*\*[^*]+\*\*|\*[^*]+\*)/g

function parseInline(text: string): ReactNode[] {
  return text.split(TOKEN).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={index}>{part.slice(1, -1)}</em>
    }
    return <Fragment key={index}>{part}</Fragment>
  })
}
